<script src="../../edit-project/edit-project.component.ts"></script>
<acabim-datatable #archivedProjectsTable [dataSources]="archivedProjectDataSources" dataKey="id">
</acabim-datatable>
<acabim-modal [title]="actionTitle" [display]="displayDataModal" (status)="setModal($event)" [footer]="false"
>
    <div *ngIf="!isProcessing else loading" class="p-d-flex flex-column">
        <div class="p-d-flex flex-row">
            <p>Do you really want to {{actionTitle}} these projects</p>
        </div>
        <div class="p-d-flex flex-row">

            <acabim-data-display [dataMap]="projectData" labelWidth="20rem"></acabim-data-display>

        </div>
        <div class="cas-action-buttons">
            <button class="cas-button-action" (click)="projectAction(true)">{{actionTitle.toUpperCase()}}</button>

            <button (click)="projectAction(false)">CANCEL</button>
        </div>
    </div>

</acabim-modal>

<ng-template #loading>
    <acabim-loading-view></acabim-loading-view>
</ng-template>

<acabim-modal [display]="displayWarningModal" dontClose="true" [title]="' '" noPadding="true">
    <acabim-data-display [dataMap]="errorMessage"></acabim-data-display>
    <div class="cas-action-buttons">
        <button class="cas-button-action" (click)="closeErrorDialog()">OK</button>
    </div>
</acabim-modal>
